import { ColorPartial } from "@mui/material/styles/createPalette";

export enum LayoutActionsTypes {
  SIDEBAR_TOGGLE = "@layout/SIDEBAR_TOGGLE",
  THEME_TOGGLE = "@layout/THEME_TOGGLE",
  RIGHTBAR_TOGGLE = "@layout/RIGHTBAR_TOGGLE",
  FEEDBACK_TOGGLE = "@layout/FEEDBACK_TOGGLE",
  DEVMODE_TOGGLE = "@layout/DEVMODE",
  SET_DEVTOOLS = "@layout/SET_DEVTOOLS",
  SET_LAYOUT_OPTION = "@layout/SET_LAYOUT_OPTION",
}

export interface IDevTools {
  thumbnailBase64?: boolean;
}

export interface ITheme {
  mode: "dark" | "light" | "auto";
  primary?: ColorPartial;
  secondary?: ColorPartial;
  inputType?: "filled" | "outlined" | "standard";
}

export interface ILayoutOption {
  aulaGeminadaPosition?: "top" | "bottom";
}

export interface LayoutState {
  sidebar: {
    isOpen: boolean;
  };
  rightbar: {
    isOpen?: boolean;
  };
  feedback?: {
    isOpen?: boolean;
  };
  option?: ILayoutOption;
  theme: ITheme;
  devMode?: boolean;
  devTools?: IDevTools;
}
